module.exports = __webpack_public_path__ + "assets/images/TigerMark-logo_3900b15df64bf70728ed2682f783ecf0.png";